const doc = [({"da":({"js":({"admin":({"subjects":({"select":({"choose_subject":"Vælg emne"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;